var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRelease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59998 2.1H17.4V3.9H6.59998V2.1ZM20.9 5.1H3.09998V6.9H20.9V5.1ZM3.39998 10C3.39998 9.94477 3.44475 9.9 3.49998 9.9H20.5C20.5552 9.9 20.6 9.94477 20.6 10V20C20.6 20.0552 20.5552 20.1 20.5 20.1H3.49998C3.44475 20.1 3.39998 20.0552 3.39998 20V10ZM3.49998 8.1C2.45063 8.1 1.59998 8.95066 1.59998 10V20C1.59998 21.0493 2.45063 21.9 3.49998 21.9H20.5C21.5493 21.9 22.4 21.0493 22.4 20V10C22.4 8.95066 21.5493 8.1 20.5 8.1H3.49998ZM13.9 14.1V12.9H16.9V11.1H13.9H12.1V12.9V14.1H10.44C9.18753 14.1 8.09998 15.0793 8.09998 16.3745V16.6254C8.09998 17.9206 9.18753 18.9 10.44 18.9H11.56C12.8124 18.9 13.9 17.9206 13.9 16.6254V15.9V14.1ZM10.44 15.9H12.1V16.6254C12.1 16.8485 11.8981 17.1 11.56 17.1H10.44C10.1018 17.1 9.89998 16.8485 9.89998 16.6254V16.3745C9.89998 16.1514 10.1018 15.9 10.44 15.9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelease);
export default __webpack_public_path__ + "static/media/release.e8a05b5660c23bbc1f6a5cb07718f587.svg";
export { ForwardRef as ReactComponent };